<template>
  <div>
    <router-link class="Logo" to="/">
      <img src="../assets/logo-red.svg" alt="Logo">
    </router-link>
    <Impressum />
    <Footer />
  </div>
</template>

<script>
import Impressum from '../components/Impressum.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'home',
  components: {
    Impressum,
    Footer
  }
}
</script>